module.exports = __webpack_public_path__ + "static/media/sider_registro.89bed31f.png";